import { useEffect, useState } from 'react';
import Item from '../../../../components/Lists/Item';
import { Sorting } from '../../../../components/Lists/Sorting';
import './DeleteAwb.scss';
import { getDetailsByAwb, getDetailsByStatus, saveAwbObj } from '../../Services/VendorApprovalService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { Bold } from '../VendorApproval/VendorApproval';
import Input from '../../../../components/Inputs/Input';
import { getAwbObj } from '../../../StoresModule/Services/PackageIntakeService';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { defQtyPropName } from '../../../../redux/features/VendorModule/VendorAwb/VendorAwbSlice';

const mockData = [
    { id: 0, orderNumber: 110, partNumber: "438792348720", serialNumber: "813279812378", qtyabr: "1 EA" }
]

const detailsMapper = (item) => ({ ...item, qtyabr: `${item[defQtyPropName]} ${item.abreviation}` });

export const DeleteAWB = ({ AWB, onClose, onSaveSuccess }) => {

    const [items, setItems] = useState([]);
    const [awbValue, setAwbValue] = useState(AWB);
    const [edition, setEdition] = useState(false);
    const [awbObj, setAwbObj] = useState(null);
    const {successMsg} =useSnackBar();


    useEffect(() => {
        getDetailsByAwb(AWB, 0).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                setItems(response.data.load.map(detailsMapper));
            }
        })
    }, []);
    
    const saveAwbNumber = () => {
        
        getAwbObj(AWB).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                let awbOb = response.data.load[0];
                saveAwbObj({...awbOb, awbNumber: awbValue}).then(response => {
                    if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                        successMsg("AWB number saved");
                        onSaveSuccess?.(awbValue);
                    }
                })
            }
        });
        setEdition(false);
    }
    const cancelChanges = () => {
        setAwbValue(AWB);
        setEdition(false);
    }

    return (
        <div className='delete-awb-component'>
            <div className='delete-header'>
                <div className='title'>
                    <b>AWB {`${edition ? "" : `- ${awbValue}`}`}</b>
                    {edition ? <><Input label="" value={awbValue} onChange={(e)=>setAwbValue(e.target.value)} />
                        <button className='awbActionBtn filledBtn' onClick={()=>saveAwbNumber()}>
                            <i className='icon-save'></i>
                        </button>
                        <button className='awbActionBtn dangerBtn' onClick={()=>cancelChanges()}>
                            <i className='icon-light-cross'></i>
                        </button></> :
                        <button className='awbActionBtn transparent' onClick={()=>setEdition(true)}>
                            <i className='icon-edit'></i>
                        </button>
                    }
                </div>
                <div className='dialog-actions'>
                    <button className='filled danger'>Delete AWB</button>


                    <button className='outlined icon small-size' onClick={onClose}>
                        <i className='icon-cross'></i>
                    </button>
                </div>
            </div>
            <b style={{ fontSize: "0.7rem" }}>Delete Individual Line Item</b>
            <div className='delete-content'>
                <Sorting displayButton={false} hideArrows properties={{ orderNumber: "Order Number", partNumber: "PN", serialNumber: "SN", quantity: "QTY" }} />
                {items.map(item =>
                    <Item renderProperty={{ qtyabr: Bold }} valuePlaceholder="--" lightFont item={item} hideLabels orderedProperties={["parentId", "partNumber", "serialNumber", "qtyabr"]} >
                        <i className='icon-delete-new'></i>
                    </Item>
                )}
            </div>
            {/* {JSON.stringify(items)} */}

        </div>
    )
}